import { render } from "./InfoPopup.vue?vue&type=template&id=27babb61&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import "./InfoPopup.vue?vue&type=style&index=0&id=27babb61&scoped=true&lang=css"
import "./InfoPopup.vue?vue&type=style&index=1&id=27babb61&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27babb61"]])

export default __exports__